<template lang="pug">
#anti_static
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_anti_static.jpg" alt="banner-certificate")
        img.img-fluid.small(src="img/banner/banner_anti_static_mobile.jpg" alt="banner-certificate")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
    div.banner_h1
      h1 Antistatic Packaging
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 Using blister equipment, using high temperature and molds, the flat plastic sheet is formed into a three-dimensional packaging curved shell, so that consumers can directly see the product and protect it.
  section#product_profile
    b-row.menu
      b-col.text-center.active APET
    b-container.pt-md-4
      b-row#apet_detail.detail.pb-5.py-md-5.active
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span Product application description
            p This product has excellent antistatic properties. There are two kinds of antistatic additives: internal addition and surface treatment. It can be applied to general electronic packaging or industrial packaging materials (such as: hardware, tools, electronic parts, electronic products, mobile phones and PDAs, etc.)
          div
            h3 
              span Product Features
            ol
              li(v-for="item in a_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span Product Information
            ol
              li(v-for="item in a_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
  section#specification.py-5.active
    div.mask
    h2.text-center 
      span  APET Specification
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_apet").swiper_apet.swiper_product_col_3
        swiper-slide(v-for="item in a_specification" :key="item.id")
          ul
              li 
                span {{ item.name }}
              li 
                span {{ item.feature }}
              li 
                span {{ item.outward }}
              li 
                span(v-html="item.thickness")
              li 
                span(v-html="item.proportion")
              li 
                span(v-html="item.transmittance")
              li 
                span(v-html="item.gloss")
              li 
                span(v-html="item.mist")
              li 
                span(v-html="item.impedance")
        <div class="swiper-pagination" slot="pagination"></div>
  section#others.py-5 
    b-container
      h3 Others
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        

</template>
<script>
export default {
    metaInfo: {
        title: 'APET Antistatic Packaging-NAN YA RIGID FILM',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'Anti-statics APET has excellent antistatic properties. There are two kinds of antistatic additives: internal addition and surface treatment. It can be applied to general electronic packaging or industrial packaging materials. There are conductive, antistatic molding, static dissipation, etc.' },
            { name: 'Keywords', content: 'Nan Ya Plastics, Rigid Film, APET, Conductive, Antistatic molding, Static dissipation' },
            { name: 'og:title', content: 'APET Antistatic Packaging-NAN YA RIGID FILM' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com/' },
            { name: 'og:description', content: 'Anti-statics APET has excellent antistatic properties. There are two kinds of antistatic additives: internal addition and surface treatment. It can be applied to general electronic packaging or industrial packaging materials. There are conductive, antistatic molding, static dissipation, etc.' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          {
            text: 'Antistatic Packaging',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data: [
          { 
            id: '1',
            img_src: 'img/application_Desktop/anti_static_img_01.jpg',
            img_alt: 'NAN YA  APET has conductive grades, antistatic grades, static dissipative grades , which can be applied to electronic packaging, industrial packaging, and Tray.' },
          { 
            id: '2',
            img_src: 'img/application_Desktop/anti_static_img_02.jpg',
            img_alt: 'NAN YA  APET has conductive grades, antistatic grades, static dissipative grades , which can be applied to electronic packaging, industrial packaging, and Tray.' },
          { 
            id: '3',
            img_src: 'img/application_Desktop/anti_static_img_03.jpg',
            img_alt: 'NAN YA  APET has conductive grades, antistatic grades, static dissipative grades , which can be applied to electronic packaging, industrial packaging, and Tray.' }
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        a_feature: [
          { message: 'Good antistatic effect.' }
        ],
        a_use: [
          { message: 'Customizable items: tanning, corona, cold resistance, anti-static, anti-fog and high frequency, etc.' },
          { message: 'Inspection specifications: ASTM D-1593, ASTM D-792, ASTM D-1003, ASTM D-523 and ASTM D-257, etc.' }
        ],
        a_specification: [
          { 
            id: '1',
            name: 'AVVC',
            feature: 'Features: Excellent antistatic effect',
            outward: 'Appearance: Transparent and colored',
            thickness: 'Thickness<sub>(mm)</sub>：0.78 ',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: 'VLT<sub>(transparent products,%)</sub>:<br/><span class="pl-5">85～92</span>',
            gloss: 'Gloss<sub>(transparent products)</sub>：<br/><span class="pl-5">120～150</span>',
            mist: 'Haze<sub>(%)</sub>：<br/><span class="pl-5">≦5.0</span>',
            impedance: 'Surface impedance<sub>（Ω/□）</sub>：<br/><span class="pl-5">10<sup>4</sup> ~ 10<sup>6</sup></span>'},
          { 
            id: '2',
            name: 'AVVE',
            feature: 'Features: Antistatic effect',
            outward: 'Appearance: Transparent and colored',
            thickness: 'Thickness<sub>(mm)</sub>：0.78 ',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: 'VLT<sub>(transparent products,%)</sub>:<br/><span class="pl-5">85～92</span>',
            gloss: 'Gloss<sub>(transparent products)</sub>：<br/><span class="pl-5">150～165</span>',
            mist: 'Haze<sub>(%)</sub>：<br/><span class="pl-5">≦4.0</span>',
            impedance: 'Surface impedance<sub>（Ω/□）</sub>：<br/><span class="pl-5">10<sup>8</sup> ~ 10<sup>10</sup></span>'},
          { 
            id: '3',
            name: 'AVVH',
            feature: 'Features: Good antistatic effect',
            outward: 'Appearance: Transparent and colored',
            thickness: 'Thickness<sub>(mm)</sub>：0.65 ',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: 'VLT<sub>(transparent products,%)</sub>:<br/><span class="pl-5">85～92</span>',
            gloss: 'Gloss<sub>(transparent products)</sub>：<br/><span class="pl-5">120～150</span>',
            mist: 'Haze<sub>(%)</sub>：<br/><span class="pl-5">≦4.5</span>',
            impedance: 'Surface impedance<sub>（Ω/□）</sub>：<br/><span class="pl-5">10<sup>6</sup> ~ 10<sup>8</sup></span>'}
        ],
        swiperOption_apet: {
          slidesPerView: 3,
          spaceBetween: 30,
          breakpoints: {
            1170: {
              spaceBetween: 30,
              slidesPerView: 'auto',
            },
            991: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'1',
            name:'Food and Medical use',
            text:'A flat plastic sheet is formed into a three-dimensional curved package by blister equipment which use high temperature and molds, so that consumers can directly see the product and protect it.',
            url:'./img/application_Desktop/other_pic_1.jpg',
            href_link: 'Food-and-medicine'
          },
          {
            id:'3',
            name:'Decoration Materials',
            text:'On a continuous substrate, products made through processes such as printing, coating, laminating or pressing. Composite plastic building materials decoration products are made by hot pressing of multi-layer structure, generally 3-5 layer structure laminated, including wear-resistant layer (including UV treatment layer), printed decoration layer, middle material layer, base material layer, etc..',
            url:'./img/application_Desktop/other_pic_3.jpg',
            href_link: 'decoration'
          },
          {
            id:'4',
            name:'Card Lamination',
            text:'This product can be processed into various cards through printing, laminating, card punching, coding, and sub-card quality inspection.',
            url:'./img/application_Desktop/other_pic_4.jpg',
            href_link: 'card_Lamination'
          },
          {
            id:'5',
            name:'For Stationery',
            text:'On a continuous substrate, products made through processes such as printing, coating, laminating or pressing for majority of Printing process.',
            url:'./img/application_Desktop/other_pic_5.jpg',
            href_link: 'office_stationery'
          },
          {
            id:'6',
            name:'Cooling Tower',
            text:'Press working and forming process are good for the product.Forming process has to regulate quality.',
            url:'./img/application_Desktop/other_pic_6.jpg',
            href_link: 'water_treatment'
          },
          {
            id:'7',
            name:'Green Apet',
            text:'GREEN APET uses PCR resins made from recycled PET bottles as its raw material, reducing emissions of carbon and waste, providing consumers with an eco-friendly products.',
            url:'./img/application_Desktop/other_pic_7.jpg',
            href_link: 'green_apet'
          },
          {
            id:'8',
            name:'C-PET SHEET',
            text:'C-PET sheet is heated and further processed by compression molding machine so that the molded product can withstand high temperatures after crystallization.',
            url:'./img/application_Desktop/other_pic_8.jpg',
            href_link: 'Cpet-sheet'
          }
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'
#anti_static
  #specification
    background-image: url(../assets/bg/bg_anti_static.jpg)

</style>
